var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleAts(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56 -41.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3508 49.4011H79.649C80.3258 49.4011 80.8716 48.8541 80.8716 48.1758V45.4626C80.8716 44.7843 80.3258 44.2373 79.649 44.2373H68.3508C67.674 44.2373 67.1282 44.7843 67.1282 45.4626V48.1758C67.1282 48.8541 67.674 49.4011 68.3617 49.4011H68.3508Z",
    fill: "#C9CBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 51.8259V67.1917C87 71.582 84.75 74.5088 79.5 74.5088H68.5C63.25 74.5088 61 71.582 61 67.1917V51.8259C61 47.4356 63.25 44.5088 68.5 44.5088H79.5C84.75 44.5088 87 47.4356 87 51.8259Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7895 44.5088H68.9649C67.8797 44.5088 67 45.3904 67 46.478V48.2066C67 49.2941 67.8797 50.1758 68.9649 50.1758H78.7895C79.8747 50.1758 80.7544 49.2941 80.7544 48.2066V46.478C80.7544 45.3904 79.8747 44.5088 78.7895 44.5088Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9945 60.7238C75.8936 60.7238 77.4331 59.181 77.4331 57.2777C77.4331 55.3744 75.8936 53.8315 73.9945 53.8315C72.0954 53.8315 70.5559 55.3744 70.5559 57.2777C70.5559 59.181 72.0954 60.7238 73.9945 60.7238Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3508 67.6162C68.3508 64.542 70.807 61.9492 74.0054 61.9492C77.2039 61.9492 79.66 64.5311 79.66 67.6162",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 4.5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleAts);
export default __webpack_public_path__ + "static/media/module-ats.455cab95.svg";
export { ForwardRef as ReactComponent };